var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportinline = function SvgReportinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 20.125h-10a.627.627 0 0 1-.625-.625v-3.75H5.75v3.75c0 1.379 1.121 2.5 2.5 2.5h10c1.379 0 2.5-1.121 2.5-2.5V8.035a2.5 2.5 0 0 0-.73-1.77L16.48 2.73A2.492 2.492 0 0 0 14.715 2H8.25a2.502 2.502 0 0 0-2.5 2.5v6.875h1.875V4.5c0-.344.281-.625.625-.625h6.25V7c0 .691.559 1.25 1.25 1.25h3.125V19.5a.627.627 0 0 1-.625.625Zm-4.188-9.215a.943.943 0 0 0-.84-.473.934.934 0 0 0-.812.52l-1.777 3.555-.977-1.469a.942.942 0 0 0-.781-.418H4.187a.935.935 0 0 0-.937.938c0 .519.418.937.938.937h4.187l1.594 2.395a.93.93 0 0 0 .84.414.949.949 0 0 0 .78-.516l1.716-3.434.383.668a.936.936 0 0 0 .812.473h1.563c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937h-1.019l-.98-1.715Z",
    fill: "#000"
  })));
};
export default SvgReportinline;